export default "__VITE_ASSET__CBF24Pur__"